import { RouteGrid } from '@components/DriverTracking/Routes/components/RouteGrid/RouteGrid'
import React from 'react'

export function RoutePage() {
  return <RouteGrid />
}
